import { render, staticRenderFns } from "./sendScope.vue?vue&type=template&id=38aa8827&scoped=true"
import script from "./sendScope.vue?vue&type=script&lang=js"
export * from "./sendScope.vue?vue&type=script&lang=js"
import style0 from "./sendScope.vue?vue&type=style&index=0&id=38aa8827&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa8827",
  null
  
)

export default component.exports